
    import React from 'react';
    import LocationFormPageContainer from './LocationFormPageContainer';
    
    export class LocationFormPage extends React.Component{
        render(){
            return (
                <LocationFormPageContainer {...this.props}/>
            )
        }
    }
    